import React from 'react';
import { Card, Badge } from 'react-bootstrap';
import { Info } from 'lucide-react';

const VariableDisplay = ({ variables, template }) => {
  if (!variables || Object.keys(variables).length === 0) {
    return null;
  }

  const variableEntries = Object.entries(variables).filter(([key, value]) => 
    value !== null && value !== undefined && value !== ''
  );

  if (variableEntries.length === 0) {
    return null;
  }

  return (
    <Card className="mb-3" style={{ backgroundColor: '#f8f9fa' }}>
      <Card.Header className="d-flex align-items-center gap-2">
        <Info size={18} />
        <strong>Resolved Variables</strong>
      </Card.Header>
      <Card.Body>
        <div className="row g-2">
          {variableEntries.map(([key, value]) => {
            // Format value for display
            let displayValue = value;
            if (typeof value === 'object') {
              displayValue = JSON.stringify(value, null, 2);
            } else if (typeof value === 'number') {
              displayValue = value.toLocaleString();
            } else {
              displayValue = String(value);
            }

            return (
              <div key={key} className="col-md-6 col-lg-4">
                <div className="variable-item">
                  <small className="text-muted d-block">{key}</small>
                  <div className="variable-value">
                    {displayValue.length > 50 
                      ? `${displayValue.substring(0, 50)}...` 
                      : displayValue}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="mt-2">
          <small className="text-muted">
            These variables are automatically populated from the selected entities. 
            You can edit the subject and body fields above.
          </small>
        </div>
      </Card.Body>
    </Card>
  );
};

export default VariableDisplay;

